import { render, staticRenderFns } from "./NationalVaccinationRecord.vue?vue&type=template&id=15a97db5&"
import script from "./NationalVaccinationRecord.vue?vue&type=script&lang=js&"
export * from "./NationalVaccinationRecord.vue?vue&type=script&lang=js&"
import style0 from "./NationalVaccinationRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports